module.exports = __webpack_public_path__ + "static/collectorcans-escape-blue-artwork-58585dd5751a25ee98bbbb6e22c5be83.png";